import { render, staticRenderFns } from "./SignDoc.vue?vue&type=template&id=11c0b1ce&scoped=true"
import script from "./SignDoc.vue?vue&type=script&lang=js"
export * from "./SignDoc.vue?vue&type=script&lang=js"
import style0 from "./SignDoc.vue?vue&type=style&index=0&id=11c0b1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0b1ce",
  null
  
)

export default component.exports